import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { TradeSectionData } from '@makemydeal/dr-activities-fuel-saving';
import { buildTradeSection } from '@makemydeal/dr-activities-fuel-saving';
import * as tradeInsSelectors from '@makemydeal/dr-dash-store/selectors/tradeIns';
import type { TradeInListItem } from '../types';

export const useFuelSavingTrades = (): TradeSectionData[] => {
    const allTradeIns = useSelector(tradeInsSelectors.getAllTradeIns) as TradeInListItem[];

    return useMemo(() => {
        return allTradeIns
            .filter((item) => item.tradeIn.shouldIncludeTradeIn)
            .map((item, index) => buildTradeSection(item.tradeIn, index, null));
    }, [allTradeIns]);
};
